import React from 'react'

const PromoImage = () => {
    return (
        <img alt="ck logo" className="ck-logo" src="https://creditkey-assets.s3-us-west-2.amazonaws.com/sdk/ck-logo%402x.png" />
    )
}

export default PromoImage
